module.exports = __webpack_public_path__ + "static/img/SK.42178613.jpg";